const Colors = {
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  SILVER_SAND: "#C4C4C4",
  AMERICAN_GREEN: "#38B54A",
  ROYAL_GREEN: "#105E00 ",
  CULTURED: "#F5F5F9 ",
  BRIGHT_GRAY: "#EAEAF0",
  RED: "#FF0000",
  TICKET_GREEN_DARK: "#b4edba",
  TICKET_GREEN_LIGHT: "#e2ffe1",
  TICKET_GRAY_DARK: "#e5ecf2",
  TICKET_GRAY_LIGHT: "#f1f6f9",
  OLIVE: "#999901",
  OLIVETONE: "#65652A",
  ERROR_RED: "#F44336",
};

export default Colors;
